import { LogsInitConfiguration } from '@datadog/browser-logs';
import { LogLevel } from './logger-types';

export const dataDogConfig: LogsInitConfiguration & { logLevel: LogLevel } = {
  clientToken: 'pub213bc6f136afdda1b7a703b92e58a042',
  site: 'datadoghq.com',
  service: 'seurat-web',
  logLevel: LogLevel.Debug,
};
